import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Language from './language';
import translationEN from './i18n/en.json';
import translationFR from './i18n/fr.json';
var defaultLanguage = Language.FR;
// the translations
var resources = {
    en: {
        translation: translationEN,
    },
    fr: {
        translation: translationFR,
    },
};
i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    resources: resources,
    lng: navigator.language,
    fallbackLng: defaultLanguage,
    keySeparator: '.', // to support nested translations
});
// custom formatters used in translations, e.g. {{value, currency-fr}}
var formatters = {
    'currency-fr': new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }),
    'currencyNoCents-fr': new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
        maximumFractionDigits: 0,
    }),
    'currency-en': new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
        maximumFractionDigits: 0,
    }),
    'currencyNoCents-en': new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }),
    'number-fr': new Intl.NumberFormat('fr-FR'),
    'number-en': new Intl.NumberFormat('en-US'),
};
Object.entries(formatters).forEach(function (_a) {
    var _b;
    var name = _a[0], numberFormat = _a[1];
    (_b = i18n.services.formatter) === null || _b === void 0 ? void 0 : _b.add(name, function (value) { return numberFormat.format(value); });
});
export default i18n;
